const ArrowRightRounded = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.9 19.15C8.27 19.15 7.68 19 7.16 18.7C5.93 17.99 5.25 16.56 5.25 14.68V9.33005C5.25 7.45005 5.93 6.02005 7.16 5.31005C8.39 4.60005 9.96 4.73005 11.6 5.67005L16.23 8.34005C17.86 9.28005 18.76 10.58 18.76 12C18.76 13.42 17.86 14.72 16.23 15.66L11.6 18.33C10.66 18.88 9.74 19.15 8.9 19.15ZM8.9 6.36005C8.53 6.36005 8.19 6.44005 7.9 6.61005C7.16 7.04005 6.75 8.00005 6.75 9.33005V14.67C6.75 15.99 7.16 16.96 7.91 17.39C8.66 17.82 9.7 17.69 10.85 17.03L15.48 14.36C16.63 13.7 17.26 12.86 17.26 12C17.26 11.14 16.63 10.3 15.48 9.64005L10.85 6.97005C10.14 6.56005 9.48 6.36005 8.9 6.36005Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRightRounded;
